<template>
  <div id="options-panel">
    <h2>Anpassa sektion</h2>
    <button class="closes-panel" v-on:click="$parent.configuringSection = false">Stäng</button>
    <div class="fields">
      <div class="field">
        <div class="field-content" v-bind:class="{'disabled': section.gate != 'none'}">
          <h3><label for="windows-top">Fönster: </label><span class="value">Övre nivå</span></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.windowTopCount == 0}" v-on:click="section.windowTopCount = 0">Inga</button>
            <button v-bind:class="{'selected': section.windowTopCount == 1}" v-on:click="section.windowTopCount = 1">1</button>
            <button v-bind:class="{'selected': section.windowTopCount == 2}" v-on:click="section.windowTopCount = 2">2</button>
            <button v-bind:class="{'selected': section.windowTopCount == 3}" v-on:click="section.windowTopCount = 3">3</button>
            <button v-bind:class="{'selected': section.windowTopCount == 4}" v-on:click="section.windowTopCount = 4">4</button>
          </div>
          <h3 v-if="section.windowTopCount > 0"><span class="value" for="">Varav öppningsbara</span></h3>
          <div v-if="section.windowTopCount > 0" class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.windowTopOpenableCount == 0}" v-on:click="section.windowTopOpenableCount = 0">Inga</button>
            <button v-bind:class="{'selected': section.windowTopOpenableCount == count}" v-for="count in parseInt( section.windowTopCount, 10)" v-bind:key="count" v-on:click="section.windowTopOpenableCount = count">{{ count }}</button>
          </div>
          
        </div>
      </div>

      <div class="field">
        <div class="field-content" v-bind:class="{'disabled': section.gate != 'none'}">
          <h3><label for="windows-bottom">Fönster: </label><span class="value">Nedre nivå</span></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.windowBottomCount == 0}" v-on:click="section.windowBottomCount = 0">Inga</button>
            <button v-if="section.door === 'none'" v-bind:class="{'selected': section.windowBottomCount == 1}" v-on:click="section.windowBottomCount = 1">1</button>
            <button v-bind:class="{'selected': section.windowBottomCount == 2}" v-on:click="section.windowBottomCount = 2">2</button>
            <button  v-if="section.door === 'none'" v-bind:class="{'selected': section.windowBottomCount == 3}" v-on:click="section.windowBottomCount = 3">3</button>
            <button v-if="section.door === 'none'" v-bind:class="{'selected': section.windowBottomCount == 4}" v-on:click="section.windowBottomCount = 4">4</button>
          </div>
          <h3 v-if="section.windowBottomCount > 0"><span class="value">Varav öppningsbara</span></h3>
          <div v-if="section.windowBottomCount > 0" class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.windowBottomOpenableCount == 0}" v-on:click="section.windowBottomOpenableCount = 0">Inga</button>
            <button v-bind:class="{'selected': section.windowBottomOpenableCount == count}" v-for="count in parseInt( section.windowBottomCount, 10)" v-bind:key="count" v-on:click="section.windowBottomOpenableCount = count">{{ count }}</button>
          </div>
          
        </div>
      </div>

      <div class="field">
        <div class="field-content" v-bind:class="{'disabled': section.gate != 'none'}">
          <h3><label for="doow">Dörr</label></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.door == 'none'}" v-on:click="section.door = 'none'">Ingen</button>
            <button v-bind:class="{'selected': section.door == 'solid'}" v-on:click="section.door = 'solid'">Ståldörr</button>
            <button v-bind:class="{'selected': section.door == 'glass'}" v-on:click="section.door = 'glass'">Aluminium, halvglas</button>

          </div>
        </div>
      </div>

      <div class="field" v-if="section.side == 'front' || section.side == 'rear'">
        <div 
        class="field-content" 
        >
          <h3><label for="level-count">Våningar</label></h3>
          <div class="buttons fullwidth align-left text-small" v-if="$parent.gableSize === 12">
            <button v-on:click="section.levelCount = 0" v-bind:class="{'selected': section.levelCount == 0}">Ingen entresolvåning</button>
            <button v-on:click="section.levelCount = 1" v-bind:class="{'selected': section.levelCount == 1}">1/2 entresol</button>
            <button v-if="section.gate === 'none'" v-on:click="section.levelCount = 2" v-bind:class="{'selected': section.levelCount == 2}">Hel entresol</button>
          </div>
          <div class="buttons fullwidth align-left text-small" v-if="$parent.gableSize === 18">
            <button v-on:click="section.levelCount = 0" v-bind:class="{'selected': section.levelCount == 0}">Ingen entresolvåning</button>
            <button v-on:click="section.levelCount = 1" v-bind:class="{'selected': section.levelCount == 1}">1/3 entresol</button>
            <button v-on:click="section.levelCount = 2" v-bind:class="{'selected': section.levelCount == 2}">2/3 entresol</button>
            <button v-if="section.gate === 'none'" v-on:click="section.levelCount = 3" v-bind:class="{'selected': section.levelCount == 3}">Hel entresol</button>

          </div>
        </div>
      </div>

      <div class="field" v-if="( section.increment > 1 && section.side == 'front') || ( section.increment > 1 && section.side == 'rear' )">
        <div
        class="field-content" 
        >
          <h3><label for="level-count">Innervägg</label></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.innerWall === 'none'}" v-on:click="section.innerWall = 'none'">Nej</button>
            <button v-bind:class="{'selected': section.innerWall === 'full'}" v-on:click="section.innerWall = 'full'">Ja</button>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="field-content borderless">
          <h3><label for="port">Port</label></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.gate === 'none' }" v-on:click="section.gate = 'none'">Ingen</button>
            <button v-bind:class="{'selected': section.gate === 'folding' }" v-on:click="section.gate = 'folding'">Vikport</button>
            <button v-bind:class="{'selected': section.gate === 'folding-electrified' }" v-on:click="section.gate = 'folding-electrified'">Elmanövrerad vikport</button>
          </div>
        </div>
      </div>

      <div class="field" v-if="section.gate !== 'none'">
        <div class="field-content">
          <h3><label for="port">Port: </label><span class="value">Typ</span></h3>
          <div class="buttons fullwidth align-left text-small">
            <button v-bind:class="{'selected': section.gateOption === 'flat' }" v-on:click="section.gateOption = 'flat'">Slät</button>
            <button v-bind:class="{'selected': section.gateOption === 'door' }" v-on:click="section.gateOption = 'door'">Dörr</button>
            <button v-bind:class="{'selected': section.gateOption === 'window' }" v-on:click="section.gateOption = 'window'">Fönster</button>
            <button v-bind:class="{'selected': section.gateOption === 'door-window' }" v-on:click="section.gateOption = 'door-window'">Dörr & Fönster</button>
          </div>
        </div>
      </div>

      <div class="field" v-if="section.gate !== 'none'">
        <div class="field-content borderless">
          <h3><label for="color">Port: </label><span class="value">Färg</span></h3>
          <div class="buttons">
            <button 
              class="padded"
              v-bind:style="{backgroundColor: color.color}"
              v-for="color in $parent.palette" 
              v-bind:key="color.color" 
              v-on:click="section.gateColor = color">
            </button>
          </div>
        </div>
      </div>

      <div class="field" v-if="false">
        <div class="field-content">
          <label for="color">Färg</label>
          <div class="buttons">
            <button 
              class="padded"
              v-bind:style="{backgroundColor: color}"
              v-for="color in $parent.palette" 
              v-bind:key="color" 
              v-on:click="section.color = color">
            </button>
          </div>
        </div>
      </div>
      <div class="field">
        <div class="field-content borderless">
          <div class="buttons fullwidth align-left text-small">
            <button class="fullwidth" v-if="($parent.gableSize == 18 && section.side == 'front' && $parent.sections.front.length > 5 ) || ($parent.gableSize == 18 && section.side == 'rear' && $parent.sections.front.length > 5)" v-on:click="$parent.removeSection(section); $parent.configuringSection = false">Ta bort sektion</button>
            
            <button class="fullwidth" v-if="($parent.gableSize == 12 && section.side == 'front' && $parent.sections.front.length > 3 ) || ( $parent.gableSize == 12 && section.side == 'rear' && $parent.sections.front.length > 3)" v-on:click="$parent.removeSection(section); $parent.configuringSection = false">Ta bort sektion</button>

            <button class="fullwidth" v-if="(section.side == 'left' && $parent.sections.left.length > 2 ) || (section.side == 'right' && $parent.sections.right.length > 2)" v-on:click="$parent.removeSection(section); $parent.configuringSection = false">Ta bort sektion</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Configuration',
  props: {
    section: Object
  },
  methods: {
    seeThroughSection(section){
      var id = section.side +'-'+ section.id;
      document.getElementById( id ).classList.add('see-through');
    },
    solidSection(section){
      var id = section.side +'-'+ section.id;
      document.getElementById( id ).classList.remove('see-through');
    },
  }
}
</script>
<style scoped lang="scss">
  @mixin mobile {
    @media (max-width: 767px) {
      @content;
    }
  }

  #options-panel {
    position: fixed;
    max-width: 250px;
    right: 10px;
    top: 10px;
    max-height: 90vh;
    overflow-y: scroll;
    padding: 0px 10px 50px;
    background: rgba(255,255,255,0.95);

    @include mobile {
      max-width: 100%;
      box-sizing: border-box;
      width: 100%;
      background: #fff;
      right: 0px;
      top: 0px;
      max-height: 50vh;
      z-index: 210;
      box-shadow: 0px 0px 32px rgba(0,0,0,0.1);
      top: 50vh;
    }

    h2 {
      margin-top: 5px;
      text-transform: uppercase;

      @include mobile {
        font-size: 15px;
      }
    }

    .closes-panel {
      position: absolute;
      top: 10px;
      right: 10px;
      background: url('../../public/icon-x-orange.png') center center no-repeat;
      background-size: 80% 80%;
      border-radius: 50%;
      border: 2px solid transparent;
      font-size: 0;
      color: transparent;
      width: 30px;
      height: 30px;
      transition: border 0.25s;

      @include mobile {
        width: 20px;
        height: 20px;
        padding: 0;
        top: 20px;
        right: 10px;
        margin-top: 10px;
        z-index: 20;
        position: fixed;
        background-color: #fff;
        top: 50vh;
      }

      &:hover {
        border: 2px solid #FF6720;
      }
    }
  }

</style>